import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Cached from '@mui/icons-material/Cached';
import useLastRefreshDate from '../../hooks/useLastRefreshDate';
import useLoadNewInvoices from '../../hooks/useLoadNewInvoices';
import LoadingIconButton from './LoadingIconButton';
import LastUpdatedDate from '../text/LastUpdatedDate';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const RefreshButton = ({
  onRefresh,
  loading,
  id,
  shouldLoadNewInvoices,
}) => {
  const [lastUpdated, refreshDateHandler] = useLastRefreshDate();
  const { loadNewInvoices, selectedCompanyHasSiiCredentials } = useLoadNewInvoices();

  const handleClick = useCallback(() => {
    onRefresh();
    refreshDateHandler();
    if (selectedCompanyHasSiiCredentials && shouldLoadNewInvoices) {
      loadNewInvoices();
    }
  }, [onRefresh, refreshDateHandler, selectedCompanyHasSiiCredentials,
    shouldLoadNewInvoices, loadNewInvoices]);

  return (
    <LoadingIconButton
      onClick={handleClick}
      loading={loading}
      color="gray"
      id={id}
      disableRipple
      disableTouchRipple
      disableElevation
    >
      <Cached className={DEFAULT_ICON_CLASS_NAME} />
      <LastUpdatedDate lastUpdated={lastUpdated} />
    </LoadingIconButton>
  );
};

RefreshButton.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  id: PropTypes.string,
  shouldLoadNewInvoices: PropTypes.bool,
};

RefreshButton.defaultProps = {
  loading: false,
  id: 'refresh-button',
  shouldLoadNewInvoices: true,
};

export default RefreshButton;
